/**
 * Query params whose values can carry people's names, by route. Telemetry (Sentry, Mixpanel)
 * passes every page URL through `redactSensitiveUrl` before it leaves the browser.
 */
const SENSITIVE_PARAMS_BY_PATH: Readonly<Record<string, readonly string[]>> = {
  '/global-search': ['q', 'roles'],
};

const REDACTED = 'redacted';
const ABSOLUTE_URL = /^[a-z][a-z\d+.-]*:/i;

/**
 * The URL with sensitive param values replaced by "redacted"; a relative URL stays relative.
 * URLs on other routes, and anything unparseable, come back unchanged.
 */
export function redactSensitiveUrl(url: string): string {
  if (!url.includes('?')) return url;
  let parsed: URL;
  try {
    parsed = new URL(url, 'http://redaction.invalid');
  } catch {
    return url;
  }
  const sensitive = SENSITIVE_PARAMS_BY_PATH[parsed.pathname.replace(/\/+$/, '')];
  if (!sensitive?.some((name) => parsed.searchParams.has(name))) return url;
  for (const name of sensitive) {
    if (parsed.searchParams.has(name)) parsed.searchParams.set(name, REDACTED);
  }
  return ABSOLUTE_URL.test(url) ? parsed.href : `${parsed.pathname}${parsed.search}${parsed.hash}`;
}
